import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { GlobalVariable } from 'src/app/global';
import { BaseComponent } from 'src/app/models/base-component';
import { EstudiantesService } from '../../services/estudiantes/estudiantes.service';
import { GeneralService } from '../../../base/services/general/general.service';
import { MateriasService } from '../../services/materias/materias.service';
import { PersistenciaService } from '../../../base/services/persistencia/persistencia.service';
import { AsistenciasService } from '../../services/asistencias/asistencias.service';
import {Md5} from 'ts-md5/dist/md5';
import { ToastrService } from 'ngx-toastr';
import { PopupConfirmacionComponent } from '../../../base/components/popup-confirmacion/popup-confirmacion.component';
import { Util } from 'src/app/utils/utils';
import { ProfesoresService } from '../../services/profesores/profesores.service';
import { UsuarioService } from '../../../base/services/usuario/usuario.service';
import { CursosService } from '../../services/cursos/cursos.service';
import { OrderPipe } from 'ngx-order-pipe';
import { PdfService } from 'src/app/base/services/pdf/pdf.service';
import { CalificacionesService } from '../../services/calificaciones/calificaciones.service';
import { FichaEconomicaEstudianteComponent } from '../ficha-economica-estudiante/ficha-economica-estudiante.component';

declare const resaltarPestañaMenu:any;

@Component({
    selector: 'app-asistencia',
    templateUrl: './asistencia.component.html',
    styleUrls: ['./asistencia.component.css'],
    standalone: false
})
export class AsistenciaComponent extends BaseComponent implements OnInit {

  gestion_actual:any;
  estudiantes:any[]=[];
  estados_asistencia:any=[];
  fechas_asistencia:any[]=[];
  estudiante_actual:any={};
  es_rol_profesor:boolean=true;
  opcion_seleccion_registro_profesor={id:0,curso:{id:0,nombre:"Seleccione el"},materia:{id:0,nombre:'curso y materia'}};
  ficha_economica_modal:NgbModalRef;

  @ViewChildren('estudiantes_lectura') estudiantes_lectura: QueryList<any>;

  constructor(public persistenciaService:PersistenciaService,
    public router:Router,
    public modalService: NgbModal,
    public generalService:GeneralService,
    public materiasService:MateriasService,
    public estudiantesService:EstudiantesService,
    public asistenciasService:AsistenciasService,
    public cursosService:CursosService,
    public toastr: ToastrService,
    private orderPipe: OrderPipe,
    public usuarioService:UsuarioService,
    public profesoresService:ProfesoresService,
    public pdfService:PdfService,
    public calificacionesService:CalificacionesService) {
    super(persistenciaService,modalService,generalService,usuarioService);
  }

  async ngOnInit(): Promise<void> {
    this.init();
    this.buscarAplicacion(this.router.url.substring(1));
    this.es_rol_profesor=Util.esRolUsuario("PROFESOR",this.usuario);
    let opcion_seleccion_empleado={id:0,persona:{id:0,nombre_completo:"Seleccione el docente"}};
    this.filter={
      registros_profesor:[this.opcion_seleccion_registro_profesor],
		  registro_profesor:this.opcion_seleccion_registro_profesor,
      intervalos_escolares:[],
      sucursales:Util.obtenerSucursalesUsuario(this.usuario),
			sucursal: Util.obtenerSucursalesUsuario(this.usuario)[0],
      empleados:[opcion_seleccion_empleado],
      empleado:opcion_seleccion_empleado,
      gestiones:[],
      gestion:{id:0,nombre_corto:"Seleccione la gestión"}
    }
    await this.obtenerEscuela();  
    await this.obtenerGestionActual();
    await this.obtenerMeses();
    await this.obtenerEstadoAsistencia();
    this.filter.gestion=this.gestion_actual;
    if(this.es_rol_profesor){
      this.obtenerRegistrosProfesor(this.usuario.id_persona,this.gestion_actual.id);
    }else{
      this.obtenerProfesores();
    }
    this.obtenerIntervalosColegio();
  }

  ngAfterViewInit() {
    resaltarPestañaMenu(this.router.url.substring(1)+"1");
    this.estudiantes_lectura.changes.subscribe(t => {
			//document.getElementById('table_asistencia').scrollLeft += 1000000;
		});
  }

  async obtenerProfesores(){
    this.blockUI.start();
    let empleados=await this.calificacionesService.obtenerProfesoresEscuela(this.filter.gestion.id,this.usuario.id_empresa).toPromise();
	  this.filter.empleados=this.filter.empleados.concat(empleados);
    this.blockUI.stop();
  }

  obtenerCursosColegio(){
    this.cursosService.obtenerCursosColegio(this.usuario.id_empresa).subscribe((cursos:any)=>{
      this.blockUI.stop();
      cursos=this.orderPipe.transform(cursos, 'orden',true);
      for(let i=0;i<cursos.length;i++){
        this.filter.registros_profesor.push({id:0,curso:cursos[i],materia:{id:0}});
      }
    });
  }

  obtenerRegistrosProfesor(id_persona,id_gestion){
	  this.profesoresService.obtenerRegistrosProfesorGestion(id_persona,id_gestion).subscribe((registros_profesor:any[])=>{
      this.filter.registros_profesor=[this.opcion_seleccion_registro_profesor].concat(registros_profesor);
    });
  }

  async obtenerGestionActual(){
    this.blockUI.start();
    let gestion_actual=(new Date().getFullYear()).toString();
    let tipo_gestion:any=await this.generalService.obtenerClasesEmpresa(this.usuario.id_empresa,GlobalVariable.Dictionary.TIPO_GESTIONES).toPromise();
    this.filter.gestiones=this.filter.gestiones.concat(tipo_gestion.clases);
    this.gestion_actual=(tipo_gestion && tipo_gestion.clases)?tipo_gestion.clases.filter(g => g.nombre==gestion_actual).length>0?tipo_gestion.clases.filter(g => g.nombre==gestion_actual)[0]:null:null;
    if(!this.gestion_actual){
      this.gestion_actual=tipo_gestion.clases.filter(g => g.nombre==((parseInt(gestion_actual)-1).toString()))[0];
    }
    this.blockUI.stop();
  }

  obtenerDatosCurso(id_curso){
    this.obtenerMateriasCurso(id_curso);
    //this.obtenerEstudiantesCurso(id_curso);
  }

  obtenerMateriasCurso(id_curso){
    this.materiasService.obtenerMateriasCurso(this.usuario.id_persona,this.gestion_actual.id,id_curso).subscribe((registros_profesor:any[])=>{
      this.filter.registros_profesor=registros_profesor;
    }); 
  }

  async obtenerEstudiantesCurso(id_sucursal,id_curso,fecha_inicio,fecha_fin){
    this.blockUI.start();
    let res:any=await this.asistenciasService.obtenerListaEstudiantes(id_sucursal,this.gestion_actual.id,id_curso,this.filter.registro_profesor.id,fecha_inicio,fecha_fin).toPromise();
    this.estudiantes=res;
    this.blockUI.stop();
  }

  establecerMateria(registro_profesor){
    this.filter.registro_profesor=registro_profesor;
    //this.buscarAsistencias();
  }

  async buscarAsistencias(){
    if(this.es_rol_profesor && this.filter.registro_profesor.id==0){
      this.toastr.info("Debe seleccionar el curso y materia!");
    }else{
      await this.obtenerEstudiantesCurso(this.filter.sucursal.id,this.filter.registro_profesor.curso.id,this.filter.fecha_inicio,this.filter.fecha_fin);
      await this.obtenerAsistenciasRegistroProfesor(this.filter.sucursal,this.filter.registro_profesor,this.filter.fecha_inicio,this.filter.fecha_fin);
      await this.verificarFechasAsistenciasEstudiantes();
      let md5=new Md5();
      let asistencia={_id:md5.appendStr(new Date().toUTCString()).end(),fecha:new Date(),estudiantes:[],id_registro_profesor:this.filter.registro_profesor.id,id_sucursal:this.filter.sucursal.id,id_curso:this.filter.registro_profesor.curso.id};
      this.fechas_asistencia.push(asistencia);
    }
  }

  generarPdfAsistenciasRegistro(){
    for(let i=0;i<this.estudiantes.length;i++){
      this.estudiantes[i].asistencias=this.orderPipe.transform(this.estudiantes[i].asistencias, 'asistencia.fecha',false);
    }
    this.pdfService.descargarPdfAsistencia(this.filter.escuela,this.fechas_asistencia,this.filter,this.estudiantes,false);
  }

  async obtenerAsistenciasRegistroProfesor(sucursal,registro_profesor,fecha_inicio,fecha_fin){
    this.blockUI.start();
    let asistencias:any=await this.asistenciasService.obtenerAsistencias(sucursal.id,registro_profesor.id,registro_profesor.curso.id,fecha_inicio,fecha_fin).toPromise();
    this.fechas_asistencia=asistencias;
    this.blockUI.stop();
  }

  async verificarFechasAsistenciasEstudiantes(){    
    for(let i=0;i<this.estudiantes.length;i++){
      for(let j=0;j<this.fechas_asistencia.length;j++){
        this.fechas_asistencia[j].fecha=new Date(this.fechas_asistencia[j].fecha);
        this.fechas_asistencia[j].fecha_texto=this.fechas_asistencia[j].fecha.getDate()+"/"+this.fechas_asistencia[j].fecha.getMonth()+"/"+this.fechas_asistencia[j].fecha.getFullYear();
        let encontrado=this.estudiantes[i].asistencias.filter(a => {
          a.asistencia.fecha=new Date(a.asistencia.fecha);
          a.asistencia.fecha_texto=a.asistencia.fecha.getDate()+"/"+a.asistencia.fecha.getMonth()+"/"+a.asistencia.fecha.getFullYear();
          return a.asistencia.fecha_texto==this.fechas_asistencia[j].fecha_texto;
        });
        if(encontrado.length==0){
          let estado_asistencia_ausente=this.estados_asistencia.filter(estado => estado.nombre=="AUSENTE")[0];
          this.fechas_asistencia[j].fecha.setHours(0);
          this.fechas_asistencia[j].fecha.setMinutes(0);
          this.fechas_asistencia[j].fecha.setSeconds(0);
          let md5=new Md5();
          this.estudiantes[i].asistencias.splice(j, 0, {_id_asistencia:md5.appendStr(this.fechas_asistencia[j].fecha.toUTCString()).end(),id_estudiante:this.estudiantes[i].id,estado:estado_asistencia_ausente,asistencia:{fecha:this.fechas_asistencia[j].fecha}});
        }
      }
    }
  }

  async obtenerEstadoAsistencia(){
    this.blockUI.start();
    let tipo_asistencia:any=await this.generalService.obtenerClases(GlobalVariable.Dictionary.TIPO_ESTADOS_ASISTENCIA).toPromise();
    this.estados_asistencia=tipo_asistencia.clases;
    this.blockUI.stop();
  }

  async obtenerIntervalosColegio(){
    this.blockUI.start();
    let tipo_intervalo:any=await this.generalService.obtenerClasesEmpresa(this.usuario.id_empresa,GlobalVariable.Dictionary.TIPO_INTERVALOS_ESCOLAR).toPromise();
    this.filter.intervalos_escolares=tipo_intervalo?tipo_intervalo.clases:[];
    this.blockUI.stop();
  }

  async generarNuevoRegistroAsistencia(asistencia){
    asistencia.modificado=true;
    asistencia.fecha_texto={
			year: asistencia.fecha.getFullYear(), 
			month: (asistencia.fecha.getMonth()+1),
			day:asistencia.fecha.getDate()
		}
    let estado_asistencia_presente=this.estados_asistencia.filter(estado => estado.nombre=="PRESENTE")[0];
    for(let i=0;i<this.estudiantes.length;i++){
      this.estudiantes[i].asistencias=this.estudiantes[i].asistencias?this.estudiantes[i].asistencias:[];
      this.estudiantes[i].asistencias.push({_id_asistencia:asistencia._id,id_estudiante:this.estudiantes[i].id,estado:estado_asistencia_presente,modificado:true});
    }
  }

  guardarAsistencia(asistencia){
    asistencia.modificado=false;
    asistencia.fecha=Util.convertirObjetoAfecha(asistencia.fecha_texto);
    this.blockUI.start();
    if(asistencia.id){
      asistencia.estudiantes=[];
      for(let i=0;i<this.estudiantes.length;i++){
        asistencia.estudiantes.push(this.estudiantes[i].asistencias.filter(asistencia_c => asistencia_c.id_asistencia==asistencia.id)[0]);
      }
      this.contarAsistencias(asistencia);
      this.asistenciasService.actualizarAsistencia(asistencia).subscribe((res:any)=>{
        this.blockUI.stop();
        this.toastr.success(res.mensaje);
        this.buscarAsistencias();
      });
    }else{
      asistencia.estudiantes=[];
      for(let i=0;i<this.estudiantes.length;i++){
        asistencia.estudiantes.push(this.estudiantes[i].asistencias.filter(asistencia_c => asistencia_c._id_asistencia==asistencia._id)[0]);
      }
      this.contarAsistencias(asistencia);
      this.asistenciasService.guardarAsistencia(asistencia).subscribe((res:any)=>{
        this.blockUI.stop();
        asistencia.id=res.id;
        this.toastr.success("Registro de asistencia guardado satisfactoriamente!");
        this.buscarAsistencias();
      });
    }
  }

  contarAsistencias(asistencia){
    asistencia.contador_asistentes=0;
    asistencia.contador_atrasados=0;
    asistencia.contador_ausentes=0;
    asistencia.contador_licencias=0;
    for(let i=0;i<asistencia.estudiantes.length;i++){
      if(asistencia.estudiantes[i] && asistencia.estudiantes[i].estado.nombre_corto=="P"){
        asistencia.contador_asistentes++;
      }
      if(asistencia.estudiantes[i] && asistencia.estudiantes[i].estado.nombre_corto=="AT"){
        asistencia.contador_atrasados++;
      }
      if(asistencia.estudiantes[i] && asistencia.estudiantes[i].estado.nombre_corto=="AU"){
        asistencia.contador_ausentes++;
      }
      if(asistencia.estudiantes[i] && asistencia.estudiantes[i].estado.nombre_corto=="L"){
        asistencia.contador_licencias++;
      }
    }
  }

  async modificarAsistencia(asistencia){
    asistencia.fecha=new Date(asistencia.fecha);
    asistencia.fecha.setHours(0);
    asistencia.fecha.setMinutes(0);
    asistencia.fecha.setSeconds(0);
    asistencia.fecha_texto={
			year: asistencia.fecha.getFullYear(), 
			month: (asistencia.fecha.getMonth()+1),
			day:asistencia.fecha.getDate()
		}
    asistencia.modificado=true;
    for(let i=0;i<this.estudiantes.length;i++){
      let asistencia_estudiante=this.estudiantes[i].asistencias.filter( ae => ae.id_asistencia==asistencia.id)[0];
      if(asistencia_estudiante){
        asistencia_estudiante.modificado=true;
      }else{
        let md5=new Md5();
        let _id_asistencia=md5.appendStr(asistencia.fecha.toUTCString()).end();
        asistencia_estudiante=this.estudiantes[i].asistencias.filter( ae => ae._id_asistencia==_id_asistencia)[0];
        if(asistencia_estudiante){
          asistencia_estudiante.modificado=true;
          asistencia_estudiante.id_asistencia=asistencia.id;
        }
      }
    }
  }

  abrirPopupConfirmacionEliminacion(asistencia){
		this.popupConfirmacion = this.modalService.open(PopupConfirmacionComponent);
		this.popupConfirmacion.componentInstance.message = "¿Esta seguro(a) de eliminar el registro de asistencia?";
		this.popupConfirmacion.componentInstance.data = asistencia;
		
		this.popupConfirmacion.componentInstance.onConfirm.subscribe(($e) => {
			if($e.confirm){
				this.eliminarAsistencia($e.data);
			}
			this.popupConfirmacion.close();
        });
	  }
	  
	eliminarAsistencia(asistencia){
		this.blockUI.start();
		this.asistenciasService.eliminarAsistencia(asistencia).subscribe((res:any) => {
      this.toastr.info(res.mensaje);
      this.blockUI.stop();
			this.buscarAsistencias();
		});
  }
  
  verEstudiante(estudiante){
    this.estudiante_actual=estudiante;
  }

  abrirCalendario(d,asistencia){
    d.toggle();
    //$("#table_asistencia").scrollLeft( 300 );
    if(!asistencia.id){
      document.getElementById('table_asistencia').scrollLeft += 1000000;
    }
  }

  crearNuevaAsistencia(){
    this.generarNuevoRegistroAsistencia(this.fechas_asistencia[this.fechas_asistencia.length-1]);
    document.getElementById('table_asistencia').scrollLeft += 1000000;
  }

  async generarPdfAsistencia(){
    this.pdfService.descargarPdfAsistencia(this.filter.escuela,new Array(26),this.filter,this.estudiantes,true);
  }

  async obtenerMeses(){
      let entidad:any=await this.generalService.obtenerClases(GlobalVariable.Dictionary.TIPO_MESES).toPromise();
      this.filter.meses=entidad.clases;
      this.filter.mes=this.filter.meses.filter(m => m.nombre_corto==(new Date().getMonth()+1))[0];
      await this.establecerFechas(this.filter.mes);
    }
  
  async establecerFechas(mes){
    let mes_fecha= new Date(parseInt(this.gestion_actual.nombre_corto),parseInt(mes.nombre_corto),0);
    this.filter.fecha_inicio = new Date(parseInt(this.gestion_actual.nombre_corto),parseInt(mes.nombre_corto)-1,1,0,0,0);    
		this.filter.fecha_fin = new Date(parseInt(this.gestion_actual.nombre_corto),parseInt(mes.nombre_corto)-1,mes_fecha.getDate(),23,59,59);
  }

  abrirFichaEconomica(estudiante){
    estudiante.inscripcion_activo=true;
      this.ficha_economica_modal = this.modalService.open(FichaEconomicaEstudianteComponent, {scrollable:true, windowClass:'ficha-economica', ariaLabelledBy: 'modal-basic-title',size: 'md', backdrop: 'static'});
      this.ficha_economica_modal.componentInstance.estudiante = estudiante;
      this.ficha_economica_modal.componentInstance.usuario = this.usuario;
      this.ficha_economica_modal.componentInstance.es_visualizacion_por_gestion = true;
      let inscripcion_colegio={gestion:this.gestion_actual,id_gestion:this.gestion_actual.id,curso:this.filter.registro_profesor.curso,id_estudiante:estudiante.id,activo:true};
      /*if(this.usuario.empresa.usar_acceso_gestion_escolar){
        if(this.usuario.datos && this.usuario.datos.gestiones){
          this.ficha_economica_modal.componentInstance.inscripcion_colegio=this.usuario.datos.gestiones.filter(id_gt => id_gt==this.filter.gestion.id).length>0?inscripcion_colegio:null;
        }      
      }else{*/
        this.ficha_economica_modal.componentInstance.inscripcion_colegio = inscripcion_colegio;
      //}
      
      this.ficha_economica_modal.componentInstance.onConfirm.subscribe(($e) => {
        if($e.confirm){
          this.getItems();
        }
        this.ficha_economica_modal.close();
      });
    }
}
